import React from 'react';
import Lozenge from '@atlaskit/lozenge';
import { useIntl } from '@atlassian/jira-intl';
import planCommonMessages from '@atlassian/jira-portfolio-3-plan-increment-common/src/messages.tsx';
import GenericReadonlyCell from '@atlassian/jira-portfolio-3-portfolio/src/app-export-view/view/component-slot-content/generic-readonly-cell';
import RollupContainer from '@atlassian/jira-portfolio-3-portfolio/src/common/view/roll-up';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';
import type { Props } from './types';

const CellSelectWithRollup = ({ value, rolledUpValues, showRolledUpOthers }: Props) => {
	const { formatMessage } = useIntl();

	const getValue = () => {
		const text = Array.isArray(value)
			? value.map((v) => v.label || '').join(', ')
			: value?.label || '';

		if (!text) {
			return null;
		}
		if (!Array.isArray(value)) {
			if (value?.isExternalTeam === true) {
				return (
					<>
						{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
						<span className={styles.textWithLozenge}>{text}</span>
						<Lozenge>{formatMessage(planCommonMessages.externalLozengeShort)}</Lozenge>
					</>
				);
			}
			if (value?.isPlanOnlyTeam === true) {
				return (
					<>
						{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
						<span className={styles.textWithLozenge}>{text}</span>
						<Lozenge>{formatMessage(planCommonMessages.planOnlyLozenge)}</Lozenge>
					</>
				);
			}
		}
		return text;
	};

	return (
		<GenericReadonlyCell
			text={
				<RollupContainer
					showRollup={showRolledUpOthers && (rolledUpValues || []).length > 0}
					isDisabled={false}
					rolledUpValues={rolledUpValues}
					withValue={!!getValue()}
					readonly
				>
					{getValue()}
				</RollupContainer>
			}
		/>
	);
};

export default CellSelectWithRollup;
